<div class="d-flex row-cols-12">
    <div class="col-12">
        <h3 class="title float-start" translate="Settings.Documents"></h3>
    </div>
</div>

<div class="mx-4 mb-4">
    <span class="pt-5 col-12" translate="Settings.ApplicationDocumentsSection.AllowedFileExtensions"></span>
    <div class="col-12 me-1 mb-2 mt-2 ps-1 border rounded allowedExtensionsInput">
        <app-tag-string-input [values]="allowedExtensionsString" (valueChanged)="newAllowedExtensionsPushed($event)"
            [onlyLowerCase]="true" [onlyLettersAndNumbers]="true" [defaultValues]="defaultExtensionsString">
        </app-tag-string-input>
    </div>
</div>
<div class="p-4 pt-0">
    <div class="mb-3 d-flex row-cols-12">
        <div class="col-8">
            <span class="pt-5 col-12" translate="Settings.ApplicationDocumentsSection.Stationery"></span>
            <app-info-button labelName="Settings.ApplicationDocumentsSection.StationeryDisclaimer"
                placement="bottom"></app-info-button>
            <div class="me-1 mb-2 mt-2">
                <div class="input-group">
                    <input type="file" class="file-input d-none" id="selectedStationery" accept=".pdf"
                        (change)="selectStationery($event)" #fileInputBG>

                    <input type="text" class="form-control stationeryInputField"
                        placeholder="{{ 'Button.ChooseFile' | translate }}" [value]="stationeryName"
                        (keyup)="changeStationeryName($event)">
                    <button class="btn btn-sm default-button browse-button" type="button"
                        (click)="removeSelected(); fileInputBG.click()" translate="Button.Browse"></button>
                    <button class="btn btn-sm btn-success" type="button" (click)="addStationery()" 
                        [disabled]="!stationeryUploaded" translate="Button.Upload"></button>
                </div>
            </div>

            <div class="w-auto row row-cols-12 mb-2">
                <app-stationery-list [stationery]="papertypes" (triggerAction)="TriggerAction($event)"
                    (removeStationery)="removeStationery($event)"
                    (papertypeChangeOrder)="papertypeChangeOrder($event)"></app-stationery-list>
            </div>
        </div>
        <div class="col-4">
            <div class="ms-4 mt-4">
                <img *ngIf="previewBackground!=null" [src]="previewBackground" alt="Stationery"
                    class="default-boxshadow w-100 previewBackground">
            </div>
        </div>
    </div>
</div>